import React from 'react';
import { Compass } from 'lucide-react';

/**
 * .pen "callout path": once the state and rung are known, the step shows the ONE
 * sentence the whole feature exists for ("Your path starts with a Limited LMSW,
 * not an exam"). The string is the backend's `firstSentence` verbatim: the
 * client never re-derives it, because two clients deriving it would eventually
 * disagree, and the wrong answer costs a learner months.
 */
export const PathCallout: React.FC<{ sentence: string }> = ({ sentence }) => (
  <div
    className="flex items-start gap-3 p-4 rounded-2xl border-2 border-neutral-200 bg-white shadow-ledge-sm"
    data-testid="licensing-path-callout"
  >
    <span className="shrink-0 w-9 h-9 rounded-full bg-primary-50 flex items-center justify-center">
      <Compass className="w-5 h-5 text-primary-600" aria-hidden="true" />
    </span>
    <span>
      <span className="block text-xs font-semibold uppercase tracking-wider text-primary-600">
        Your path
      </span>
      <span className="block text-base font-semibold text-neutral-900">{sentence}</span>
    </span>
  </div>
);

export default PathCallout;
